import { Service } from '@tino-frontend/adapters'

import type {
  RatingsResumeResponse,
  Places,
  ClientProfile,
  ClientCreditAnalysis,
  SocialMedia,
  CompanyChanges,
  CompanyFiscalInfo,
  ClientInfo,
  BureauMerchantAddresses,
  CompanyDataDTO,
} from '@types'

import { UserState } from 'modules/user/stores'

export class ClientProfileService {
  constructor(
    private readonly http: Service,
    private readonly supplierBff: Service
  ) {}

  async getInfo(
    supplierId: string,
    documentNumber: string
  ): Promise<ClientInfo> {
    return this.supplierBff.get(
      `v2/suppliers/${supplierId}/merchants/${documentNumber}`
    )
  }

  async getAnalysis(
    requester_supplier_id: string,
    document_number: string
  ): Promise<ClientCreditAnalysis> {
    return this.supplierBff.post(`v1/request-credit-analysis`, {
      requester_supplier_id,
      document_number,
    })
  }

  async getProfile(
    supplierId: string,
    documentNumber: string
  ): Promise<ClientProfile> {
    return this.supplierBff.get(
      `v1/merchant-profile?merchant_document_number=${documentNumber}&supplier_id=${supplierId}`
    )
  }

  async getPlacePhotos(address: string, placeName: string): Promise<Places> {
    return this.supplierBff.get(`v1/places`, {
      params: {
        address,
        place_name: placeName,
      },
    })
  }

  async getSocialMedias(
    companyName: string,
    documentNumber: string,
    address: string
  ): Promise<SocialMedia[]> {
    return this.supplierBff.get(
      `/v1/social-media?company_name=${companyName}&company_document_number=${documentNumber}&address=${address}`
    )
  }

  async getAIResume({
    profile,
    user,
  }: {
    profile: ClientProfile
    user: UserState
  }): Promise<RatingsResumeResponse> {
    return this.http.post(
      'https://tino.app.n8n.cloud/webhook/a35110ec-aadb-4bd4-9de8-54a5ba61a16b',
      {
        ratings: profile,
        user,
      }
    )
  }

  async getFiscalInfo(documentNumber: string): Promise<CompanyFiscalInfo> {
    return this.supplierBff.get(
      `/v2/merchants/sintegra-ws/cnpj/${documentNumber}/fiscal-registration`
    )
  }

  async getCompanyChanges(documentNumber: string): Promise<CompanyChanges> {
    return this.supplierBff.get(
      `v1/companies/${documentNumber}/registration-changes`
    )
  }

  async getClientAddress(cnpj: string): Promise<BureauMerchantAddresses> {
    return this.supplierBff.get(`v2/merchants/address?document_number=${cnpj}`)
  }

  async getCompanyData(documentNumber: string): Promise<CompanyDataDTO> {
    return this.supplierBff.get(
      `v2/merchants/receita-ws?document_number=${documentNumber}`
    )
  }
}
